export default "__VITE_ASSET__shPaA7OJ__"